import React from 'react';
import { STUDY_RESOURCES } from '../constants';
import { resolveResource } from '../affiliateLinks';
import { examLabel } from '../names';
import { Icon } from './ui';

// Editorial, not a storefront (brief 030): the order never changes because a link pays,
// affiliate links are labelled and disclosed, and links open in the browser as given.
function Resources({ userProfile, onGoToProfile }) {
  const list = userProfile?.studyCategory ? STUDY_RESOURCES[userProfile.studyCategory] : null;
  const resources = list && list.map(r => resolveResource(r));
  const anyAffiliate = !!resources?.some(r => r.affiliate);
  return (
    <>
      <p className="page-sub">{userProfile?.studyCategory ? `Top resources for ${examLabel(userProfile.studyCategory)}` : 'Complete your profile to see personalized recommendations'}</p>
      {anyAffiliate && (
        <p className="resources-disclosure">Some links are affiliate links: MedXMeet may earn a commission if you buy, at no extra cost to you. We list what students actually use, whether or not it pays us.</p>
      )}
      {resources ? (
        <div className="resources-grid">
          {resources.map(r=>(
            <div key={r.id} className="resource-card">
              {r.popular&&<span className="chip accent">Widely used</span>}
              <div className="resource-name">{r.name}</div>
              <div className="resource-description">{r.desc}</div>
              {r.why&&<p className="resource-why">{r.why}</p>}
              {(r.free||r.affiliate)&&(
                <div className="resource-meta">
                  {r.free&&<div className="resource-price">Free</div>}
                  {r.affiliate&&<div className="resource-affiliate">Affiliate link</div>}
                </div>
              )}
              {/* Same external open as before (Safari in the app); the link goes out exactly as configured. */}
              <button className="btn-small secondary" onClick={()=>window.open(r.href,'_blank')}>Visit site<Icon name="external" size={16} /></button>
            </div>
          ))}
        </div>
      ) : (
        <div className="card empty-state">
          <div className="empty-icon"><Icon name="book" size={40} /></div>
          <p className="small">Choose your exam in Profile to see resources for it.</p>
          <button className="btn-small secondary" onClick={onGoToProfile} style={{marginTop:'16px'}}>Go to Profile</button>
        </div>
      )}
    </>
  );
}
export default Resources;
